<template>
  <div>
     <contract-side-view
       :isSidebarActive="contractSidebarActive"
      @closeSidebar="toggleContractDataSidebar"
      :data="contractSidebarData"
      @onContractUpdated="contractUpdated"
      @onContractInserted="contractInserted"
    />
    <vx-card ref="listCard" :title="$t('Drilling.Contracts.Title')" title-color="black" refresh-content-action @refresh="getContracts"> 
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          ref="contractTable"
          search
          :data="filteredContracts"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <vs-row vs-type="flex" vs-justify="space-between">
              <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="12">
                <feather-icon icon="PlusCircleIcon" class="cursor-pointer mr-5" svg-classes="h-6 w-6" @click="addContract" />
              </vs-col>
            </vs-row>
          </div>
          <template slot="thead">
            <vs-th>{{$t('Action')}}</vs-th>
            <vs-th sort-key="code">{{$t('Drilling.Contracts.Code')}}</vs-th>
            <vs-th sort-key="location">{{$t('Drilling.Contracts.Location')}}</vs-th>
            <vs-th sort-key="property">{{$t('Drilling.Contracts.Property')}}</vs-th>
            <vs-th sort-key="state">{{$t('Drilling.Contracts.State')}}</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td width="150px" class="whitespace-no-wrap">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editContract(tr)"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="openDeleteConfirm(tr.contractId)"
                  />
                </vs-td>
                <vs-td >
                  <p class="font-medium truncate">{{ tr.code }}</p>
                </vs-td>
                <vs-td >
                  <p class="font-medium truncate">{{ tr.location }}</p>
                </vs-td>
                <vs-td >
                  <p class="font-medium truncate">{{ tr.property }}</p>
                </vs-td>
                <vs-td >
                  <p class="font-medium truncate">{{ tr.state }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>
<script>

import moduleDrilling from "../store/moduleDrilling.js";
import contractSideView from "./components/contractSideView.vue"

export default {
  components: {
    contractSideView
  },
  data() {
    return {
      contractSidebarActive: false,
      contractSidebarData: {},
    };
  },

  computed: {
    filteredContracts() {
      return this.$store.state.drilling.contracts.filter(c => c.mainProjectId === this.mainProjectId);
    },
    mainProjectId() {
      return Number(this.$store.state.projectId);
    }
  },
  mounted() {
    this.$vs.loading();
    this.$store.dispatch("drilling/fetchAllCompanies").then(() => {
      this.$refs.listCard.refreshcard();
    }).finally(() => {
      this.$vs.loading.close();
    })    
  },
  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }
  },
  methods: {
    addContract() {
      this.contractSidebarData = {};
      this.toggleContractDataSidebar(true);
    },
    editContract(data) {
      this.contractSidebarData = data;
      this.toggleContractDataSidebar(true);
    },
    toggleContractDataSidebar(val = false) {
      this.contractSidebarActive = val;
    },
    contractUpdated() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });

      this.toggleContractDataSidebar(false);

    },

    contractInserted() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleContractDataSidebar(false);
    },
  
    getContracts() {
      this.$store.dispatch("drilling/fetchAllContracts").finally(() => {
        this.$refs.listCard.removeRefreshAnimation()
      });
    },

    openDeleteConfirm(contractId) {
      this.$deleteConfirmation({
        text: this.$t('Drilling.Contracts.ConfirmDelete'),
        accept: () => this.deleteContract(contractId)
      });
    },

    deleteContract(id) {
      this.$store.dispatch("drilling/removeContract", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Drilling.Contracts.ContractDeleted"));
          this.$refs.listCard.refreshcard();
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.listCard.refreshcard();
          }
        });
    }
  }
};
</script>
<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
